export default "__VITE_ASSET__DyTv8yml__"